import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { coerceBoolean } from "@obg/ngx.global.evo";

@Component({
	selector: "obg-deposit-limit-item-actions",
	templateUrl: "deposit-limit-item-actions.component.html",
	styleUrls: ["./deposit-limit-item-actions.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepositLimitItemActionsComponent {
	@Input() @coerceBoolean() setDepositLoading = false;
	@Input() @coerceBoolean() redirectToDeposit = false;
	@Input() @coerceBoolean() sessionLimitsUnset = false;
	@Input() @coerceBoolean() invalid = false;
	@Input() limitKey!: string;

	@Output() formSubmit = new EventEmitter();
	@Output() cancel = new EventEmitter();
}
